import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Grid } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import SearchIcon from "@mui/icons-material/Search";
import ComplaintsTab from "./ComplaintsTab";

function ComplaintsPage() {
  // const navigate = useNavigate();
  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12}>
            <h1 className="panelHeading">
              {/* <ArrowBackIcon
                className="backArrow"
                onClick={() => navigate("/Dashboard")}
              /> */}
              Complaints
            </h1>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <div className="complaintsTbMain">
              {/* <div className="visitorSearchDiv">
                <SearchIcon className="visitorSearchIco" />
                <input type="text" placeholder="Search" />
              </div> */}
              <div className="complaintsTb" style={{ marginTop: 0 }}>
                <ComplaintsTab />
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default ComplaintsPage;
